import styled, { css } from "styled-components";
import { theme } from "../../../../../shared-components/deprecated-styled-components/lexus/theme/lexusTheme";

export const Indicator = styled.div<{ position?: "left" | "right" }>`
    display: flex;
    position: relative;
    align-items: center;

    label {
        display: inline-flex;
        position: relative;
        width: 100%;
        margin: 0;
        padding-block: 0;
        font-family: ${theme.fonts.regular};
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${theme.colors.platinumDark};
        cursor: pointer;

        @supports not (padding-inline: 0) {
            padding-right: 20px;

            html[dir="rtl"] & {
                padding-left: 20px;
                padding-right: 0;
            }
        }

        /* Custom style checkbox */
        &::before {
            display: block;
            position: absolute;
            top: 2px;
            width: 20px;
            height: 20px;
            content: "";
            border: 1px solid ${theme.colors.platinumLight};
            border-radius: 50%;
            cursor: pointer;
        }

        ${({ position }) =>
            position === "left"
                ? css`
                      &::before {
                          inset-inline-start: 0;
                          @supports not (inset-inline: 0) {
                              left: 0;

                              html[dir="rtl"] & {
                                  left: auto;
                                  right: 0;
                              }
                          }
                      }
                  `
                : css`
                      &::before {
                          inset-inline-end: 0;
                          @supports not (inset-inline: 0) {
                              right: 0;

                              html[dir="rtl"] & {
                                  left: 0;
                                  right: auto;
                              }
                          }
                      }
                  `}
    }

    input {
        position: absolute;
        width: 10px;
        height: 10px;
        white-space: nowrap;
        opacity: 0;
        overflow: hidden;

        ${({ position }) =>
            position === "left"
                ? css`
                      inset-inline-start: ${theme.space[2]}px;
                      @supports not (inset-inline: 0) {
                          left: ${theme.space[2]}px;

                          html[dir="rtl"] & {
                              left: auto;
                              right: ${theme.space[2]}px;
                          }
                      }
                  `
                : css`
                      inset-inline-end: ${theme.space[2]}px;
                      @supports not (inset-inline: 0) {
                          right: ${theme.space[2]}px;

                          html[dir="rtl"] & {
                              left: ${theme.space[2]}px;
                              right: auto;
                          }
                      }
                  `}
    }

    input:checked + label::before {
        background-color: ${theme.colors.white};
        border-color: ${theme.colors.platinumLight};
    }

    input:checked + label::after {
        display: block;
        position: absolute;
        top: 5px;
        width: 14px;
        height: 14px;
        content: "";
        background-color: ${theme.colors.azure};
        border-radius: 50%;
        cursor: pointer;

        ${({ position }) =>
            position === "left"
                ? css`
                      inset-inline-start: 3px;
                      @supports not (inset-inline: 0) {
                          left: 3px;

                          html[dir="rtl"] & {
                              left: auto;
                              right: 3px;
                          }
                      }
                  `
                : css`
                      inset-inline-end: 3px;
                      @supports not (inset-inline: 0) {
                          right: 3px;

                          html[dir="rtl"] & {
                              left: 3px;
                              right: auto;
                          }
                      }
                  `}
    }

    input:disabled + label {
        color: ${theme.colors.disabledDark};
        cursor: default;
        &::before {
            background-color: ${theme.colors.disabledLight};
            border-color: ${theme.colors.disabledDark};
            cursor: default;
        }
    }

    &:hover {
        label::before {
            background-color: ${theme.colors.azureHover};
        }
    }

    &:focus-within {
        label::before {
            outline: 2px solid ${theme.colors.outline};
            outline-offset: 2px;
        }
    }
`;
